import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import locales from "../../../_constants/locales";
import "../../../styles/Input.css";
import "../Styles/_InvoiceWindow.css";
import "../Styles/_OrderPopupSimpleWindow.css";
import { Confirmed } from "./_Icon";

let scrolled_into_view = false;

export class InvoiceOrderWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            invoiceGenerateErrorMessage: "",
            additionalInfo: "",
            invoiceGenerated: false
        };
        this.resetState();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.open === false && this.props.open === true) {
            this.resetState();
        }

        if (this.props.loading === false && prevProps.loading === true && !this.props.err) {
            this.resetErrorMessages();
            this.setState({
                invoiceGenerated: true
            });
        } else if (this.props.loading === false && prevProps.loading === true && this.props.err) {
            this.setState({
                invoiceGenerateErrorMessage: locales[this.props.store[0]][this.props.language].ORDER_PAGE.INVOICE_SECTION.ERROR_FAILED
            });
        }
    }

    scrollWindowIntoView = () => {
        const element = document.getElementById("invoice-window");

        if (element && !scrolled_into_view) {
            element.scrollIntoView({
                behavior: "auto",
                block: "start",
                inline: "center"
            });
            scrolled_into_view = true;

            this.postMessageToParentWindow();
        }
    };

    postMessageToParentWindow = () => {
        const data = {
            action: "DIALOG_WINDOW_OPEN"
        };

        window.parent.window.postMessage(JSON.stringify(data), "*");
    };

    handleCancelClick = () => {
        this.resetErrorMessages();
        this.props.handleCloseInvoiceDialog();
    };

    resetState = () => {
        this.setState({
            additionalInfo: "",
            invoiceGenerated: false
        });
        scrolled_into_view = false;
    };

    handleSubmitClick = () => {
        this.resetErrorMessages();
        this.props.generateInvoice(this.props.order_id, this.props.language, this.state.additionalInfo);
    };

    resetErrorMessages = () => {
        this.setState({
            invoiceGenerateErrorMessage: ""
        });
    };

    handleEnter = () => {
        this.resetErrorMessages();
    };

    handleInputChange = e => {
        if (e.target.name === "additional_info" && e.target.value.length <= 24) {
            this.setState({
                additionalInfo: e.target.value
            });
        }
    };

    render() {
        const {
            ORDER_PAGE: { INVOICE_SECTION },
            MISC
        } = this.props.currentLanguage;

        return (
            <div className="flex layout vertical">
                <Dialog
                    classes={{
                        paper: "popup-simple-window-dialog-paper"
                    }}
                    scroll="body"
                    className="order-invoice-dialog"
                    disableBackdropClick
                    disableEscapeKeyDown
                    aria-labelledby="simple-dialog-title"
                    open={this.props.open}
                    onEnter={this.handleEnter}
                >
                    <div id="popup-simple-window" className="layout vertical popup-simple-window invoice-window relative">
                        <div className="flex layout horizontal">
                            <div className="flex"></div>
                            <CloseIcon className="layout vertical center-center close-corner-button" onClick={this.handleCancelClick} />
                        </div>
                        <div className="flex layout vertical relative">
                            <div className="flex layout vertical popup-simple-window-inner">
                                {this.props.loading && (
                                    <div className={`loading-box fit layout vertical center-center`}>
                                        <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                                    </div>
                                )}
                                <div className="layout vertical header">
                                    <p className="layout vertical center-center title">{INVOICE_SECTION.HEADING}</p>
                                </div>
                                {!this.state.invoiceGenerated && (
                                    <React.Fragment>
                                        <div className="layout vertical body">
                                            <p className="layout vertical center-center sub-title">{INVOICE_SECTION.SUBHEADING}</p>
                                            <div className="additional-tax-info-box">
                                                <div className="input-box">
                                                    <div className="flex layout justified horizontal input-header">
                                                        <div className="input-heading">{INVOICE_SECTION.ADDITIONAL_TAX_INFO_HEADER}</div>
                                                    </div>
                                                    <div className="flex layout horizontal input-body">
                                                        <input
                                                            name="additional_info"
                                                            placeholder="VAT/NIF/IVA 12345"
                                                            onChange={this.handleInputChange}
                                                            className="custom-input"
                                                            value={this.state.additionalInfo}
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="layout vertical footer">
                                            {this.state.invoiceGenerateErrorMessage && (
                                                <div className="message-box">{this.state.invoiceGenerateErrorMessage}</div>
                                            )}
                                            <div className="layout vertical buttons-box">
                                                <div className="flex layout dynamic-direction-mobile-portrait buttons">
                                                    <button className="flex custom-button negative" onClick={this.handleCancelClick}>
                                                        <div className="layout vertical center-center inbutton-text">{MISC.CLOSE}</div>
                                                    </button>
                                                    <button
                                                        className={`flex custom-button ${this.props.loading ? "loading" : ""}`}
                                                        style={{ float: "right" }}
                                                        onClick={this.props.loading ? null : this.handleSubmitClick}
                                                    >
                                                        <div className="layout vertical center-center inbutton-text">{MISC.SUBMIT}</div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )}
                                {this.state.invoiceGenerated && (
                                    <React.Fragment>
                                        <div className="layout vertical body">
                                            <div className="flex layout horizontal center-center">
                                                <Confirmed fill="#BF0000" />
                                                <p style={{ margin: "0px 10px" }}>{INVOICE_SECTION.SUCCESS_MESSAGE}</p>
                                            </div>
                                        </div>
                                        <div className="layout vertical footer">
                                            <div className="flex layout dynamic-direction-mobile-portrait buttons">
                                                <button className="flex custom-button negative" onClick={this.handleCancelClick}>
                                                    <div className="layout vertical center-center inbutton-text">{MISC.CLOSE}</div>
                                                </button>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

export default withRouter(InvoiceOrderWindow);
